import { createModel } from '@rematch/core';

interface CurrentPageState {
	urls: Record<string, any>;
	title: Record<string, any>;
	image: string;
	imagePress: string;
	project: string;
}

const initialState: CurrentPageState = {
	urls: {},
	title: {},
	image: "", 
	imagePress: "", 
	project: "",
}

export const currentPageModel = createModel()({
	state: { ...initialState },
	reducers: {
		UPDATE: (state, key, value) => {
			return {
				...state,
				[key]: value,
			};
		},
		setUrls(state, res) {
			return {
				...state,
				urls: res,
			};
		},  
		setImage(state, res) {
			return {
				...state,
				image: res,
			};
		},	setImagePress(state, res) {
			return {
				...state,
				imagePress: res,
			};
		},
		setTitle(state, res) {
			return {
				...state,
				title: res,
			};
		},		setProject(state, res) {
			return {
				...state,
				project: res,
			};
		},
	},
	effects: (dispatch) => ({

 




	}),

})